import { type FC } from "react";
import { type BaseFieldProps, Field, type WrappedFieldProps } from "redux-form";

import { TriggerButton } from "widgets";

export interface BooleanInputProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

/**
 * 3-states boolean field
 */
const BooleanInput: FC<BooleanInputProps> = (props) => {
  const { value, onChange } = props;

  if (value == undefined) {
    return (
      <TriggerButton
        label={"Not Set"}
        icon={"do_not_disturb_on"}
        onPress={() => onChange(true)}
        data-testid={"undefined"}
        style={{ color: "#8E8E90" }}
      />
    );
  } else if (value == true) {
    return (
      <TriggerButton
        label={"Yes"}
        icon={"check_circle"}
        onPress={() => onChange(false)}
        data-testid={"yes"}
        style={{ color: "#46769A" }}
      />
    );
  } else {
    return (
      <TriggerButton
        label={"No"}
        icon={"cancel"}
        onPress={() => onChange(null)}
        data-testid={"no"}
        style={{ color: "#B5183F" }}
      />
    );
  }
};

const BooleanField: FC<BaseFieldProps & Partial<WrappedFieldProps>> = (field) => {
  return <BooleanInput key={field.input.name} value={field.input.value} onChange={field.input.onChange} />;
};

export default BooleanInput;

export function ThreeStatesBooleanReduxFormField(props: BaseFieldProps) {
  /*
  Regarding "format={null}", the redux-form documentation states :
  To respect React 15 input behavior there is defaultFormat = value => value == null ? '' : value internally used. To disable that you can pass null as format prop.
   */
  return <Field component={BooleanField} {...props} format={null} />;
}
